import {
  FormControlLabel,
  Switch as MUISwitch,
} from '@mui/material';
import React from 'react';

type SwitchProps = {
  disabled?: boolean;
  name?: string;
  label: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  size?: 'small' | 'medium';
  checked: boolean;
  handleBlur?: any;
  handleOnChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  inputRef?: any;
};

const noop = () => {};

const Switch = ({
  disabled = false,
  name,
  label,
  labelPlacement = 'end',
  size = 'medium',
  checked,
  handleBlur,
  handleOnChange = noop,
  inputRef,
}: SwitchProps) => (
  <FormControlLabel
    disabled={disabled}
    name={name}
    label={label}
    labelPlacement={labelPlacement}
    inputRef={inputRef}
    control={(
      <MUISwitch
        size={size}
        checked={checked}
        onBlur={handleBlur}
        onChange={handleOnChange}
      />
    )}
  />
);

export default Switch;
